import React, { createContext, useContext, useState } from "react";

interface ConversationContextProps {
  hasConversation: boolean;
  setHasConversation: React.Dispatch<React.SetStateAction<boolean>>;
  conversationLoading: boolean;
  setConversationLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const WhatsAppConversationContext =
  createContext<ConversationContextProps | null>(null);

export default function WhatsAppConversationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [hasConversation, setHasConversation] = useState<boolean>(false);
  const [conversationLoading, setConversationLoading] = useState<boolean>(true);

  return (
    <WhatsAppConversationContext.Provider
      value={{
        hasConversation,
        setHasConversation,
        conversationLoading,
        setConversationLoading,
      }}
    >
      {children}
    </WhatsAppConversationContext.Provider>
  );
}

export const useWhatsAppConversation = () => {
  const context = useContext(WhatsAppConversationContext);
  if (!context) {
    throw new Error(
      "useWhatsAppConversation must be used within WhatsAppConversationProvider",
    );
  }
  return context;
};
